import React, { useState } from 'react';
import TelsimStockHead from './Components/Header'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import PidVerification from './Components/PidVerification'
import StockListing from './Components/StockListing'
import CartPage from './Components/CartPage'
import Summary from './Components/SummaryPage';
import "./TelsimStock.css";






function TelsimStockRequest() {

  const [showPlans, setShowPlans] = useState(true)
  const [showCart, setShowCart] = useState(false)
  const [showSummary, setShowSummary] = useState(false)
  const [cartData, setCartData] = useState([])
  const[summaryData,setSummaryData]=useState([])

  const getShowCart = (input, data) => {
    setShowPlans(false)
    setShowCart(input)
    setCartData(data)

  }

  const ShowSummary=(input)=>{
    setShowSummary(input)
  }


   const getShowPlans=()=>{
    setShowPlans(true)
    setShowSummary(false)

   }

  const handleCartBack=(input)=>{
    setShowCart(input)
  }








  return (
    <div>
      <DashboardLayout>
        <DashboardNavbar />

        {showPlans && <StockListing getShowCart={getShowCart} />}
        {showCart && <CartPage cart={cartData}  setShowSummary={ShowSummary}  getShowCart={getShowCart}  setSummaryData={setSummaryData}  handleCartBack={handleCartBack}  getShowPlans={getShowPlans}/>}
        {showSummary && <Summary summaryData={summaryData} getShowPlans={getShowPlans} />}

      </DashboardLayout>
    </div>
  )
}

export default TelsimStockRequest